import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
// import { PROFILE_INFO_STEP } from "../../route/AppRouter";
import { PAYMENT } from '../../api/EndPoints';
import ProfileForm from '../../form/profile/ProfileForm';
import EmployeeForm from '../../form/profile/ProfileEmployeeForm';
import DeclarationForm from '../../form/profile/ProfileDeclarationForm';
import IdentityForm from '../../form/profile/ProfileIdentityForm';
// import LicenseForm from "../../form/profile/LicenseForm";
import PaymentForm from '../../form/profile/ProfilePaymentForm';
import YFSelect from '../../form/elements/YFSelect';
import { useCookies } from 'react-cookie';
import usePaymentSession from '../../session/PaymentSession';
import { getDocuments, createDocument } from '../../api';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { Tabs, Tab, Box } from '@material-ui/core';
import { Layout, Row, Col, Upload, Alert } from 'antd';
import { PlusOutlined, FileTextOutlined } from '@ant-design/icons';
import profileStore from '../../form/profile/profileStore';
const { Content } = Layout;

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}
function TabContainer(props) {
    const tabTheme = createMuiTheme({
        palette: {
            primary: {
                main: '#f47d29',
            },
            secondary: {
                main: '#253592',
            },
        },
    });
    return (
        <ThemeProvider theme={tabTheme}>
            <Tabs value={0} {...props} indicatorColor="primary" />
        </ThemeProvider>
    );
}

const Profile = () => {
    const history = useHistory();
    const [selectedTab, setSelectedTab] = useState(0);
    const [user, setUser] = useState(profileStore.initialState.user);
    const [cookies] = useCookies(['SESSION']);
    if (cookies.SESSION === undefined) {
        history.push('/');
        window.location.reload(false);
    }

    usePaymentSession(PAYMENT);
    const { token_type, access_token } = cookies.SESSION;
    const token = `${token_type} ${access_token}`;

    useEffect(() => {
        profileStore.subscribe(setUser);
    }, [token]);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <Content className="profileFormContainer">
            <div>
                <TabContainer value={selectedTab} onChange={handleTabChange} variant="standard">
                    <Tab label="Information" {...a11yProps(0)} />
                    <Tab label="Employee" {...a11yProps(1)} />
                    <Tab label="Identity" {...a11yProps(2)} />
                    <Tab label="Declaration" {...a11yProps(3)} />
                    {/* <Tab label="License" {...a11yProps(4)} /> */}
                    <Tab label="Payment" {...a11yProps(4)} />
                    <Tab label="Documents" {...a11yProps(5)} />
                </TabContainer>
                <TabPanel value={selectedTab} index={0}>
                    <ProfileForm user={user} />
                </TabPanel>
                <TabPanel value={selectedTab} index={1}>
                    <EmployeeForm value={user?.employee} />
                </TabPanel>
                <TabPanel value={selectedTab} index={2}>
                    <IdentityForm value={user?.identity} />
                </TabPanel>
                <TabPanel value={selectedTab} index={3}>
                    <DeclarationForm
                        token={token}
                        value={{
                            statement: user?.statement,
                            loans: user?.loans,
                            livingExpense: user?.livingExpense,
                            relationships: user?.relationships,
                        }}
                    />
                </TabPanel>
                {/* <TabPanel value={selectedTab} index={4}>
          <LicenseForm value={user?.license}/>
        </TabPanel> */}
                <TabPanel value={selectedTab} index={4}>
                    <PaymentForm token={token} value={user?.payments} />
                </TabPanel>
                <TabPanel value={selectedTab} index={5}>
                    <Document token={token} />
                </TabPanel>
            </div>
        </Content>
    );
};

const Document = ({ token }) => {
    const [selectedDocument, setSelectDocument] = useState([]);
    const [documents, setDocument] = useState([]);
    const [documentType, setDocumentType] = useState('');
    const [error, setError] = useState({ message: undefined });

    const fileProps = {
        accept: 'image/*,.pdf',
        listType: 'text',
        onRemove: (file) => {
            const index = documents.indexOf(file);
            const newFileList = documents.slice();
            newFileList.splice(index, 1);
        },
        beforeUpload: (file) => {
            setDocument([file]);
            setError({ message: undefined });
            return false;
        },
        documents,
    };

    const handleSelectDocumentType = ({ name, value }) => {
        setDocumentType(value);
        setError({ message: undefined });
    };

    const handleDocumentSubmit = () => {
        if (documentType === '') {
            setError({ message: 'Choose document type.' });
            return;
        }
        if (documents.length === 0) {
            setError({ message: 'Choose document.' });
            return;
        }

        const form = new FormData();
        form.append('type', documentType);
        form.append('url', documents[0]);
        form.append('name', '----');
        form.append('remark', '----');

        createDocument({ token, request: form })
            .then((response) => {
                setSelectDocument([...selectedDocument, response.data]);
                setDocument([]);
            })
            .catch((error) => {
                if (error) {
                }
            });
    };

    useEffect(() => {
        getDocuments({ token })
            .then((response) => {
                setSelectDocument(response.data);
            })
            .catch((error) => {});
    }, [token]);

    return (
        <div className="documentContainer">
            {error.message !== undefined && <Alert message={error.message} type="error" showIcon />}

            {selectedDocument.length !== 0 && (
                <div className="horizontal-container">
                    {selectedDocument.map((doc, key) => {
                        const filelink = doc.url;
                        if (filelink.substr(filelink.lastIndexOf('.') + 1) === 'pdf') {
                            return (
                                <div style={{ display: 'block' }}>
                                    <a target="_blank" href={filelink} rel="noopener noreferrer">
                                        <FileTextOutlined style={{ fontSize: 100, textAlign: 'center' }} />
                                    </a>
                                    <label>{doc.type}</label>
                                </div>
                            );
                        } else {
                            return <img className="documentPreview" src={doc.url} alt={''} key={key} />;
                        }
                    })}
                </div>
            )}
            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <YFSelect
                        id="profile-document"
                        name="document"
                        label="Document Type"
                        placeholder="Select Document Types"
                        options={documentTypes}
                        handleChange={handleSelectDocumentType}
                    />
                </Col>
            </Row>
            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <Upload id="profile-document-picker" {...fileProps} fileList={documents}>
                        <div className="documentItem">
                            <PlusOutlined className="plusIcon" style={{ fontSize: 50, alignSelf: 'center' }} />
                        </div>
                    </Upload>
                </Col>
            </Row>
            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                ></Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <input type="submit" className="documentSubmit" onClick={() => handleDocumentSubmit()} />
                </Col>
            </Row>
        </div>
    );
};

const documentTypes = [
    { label: 'Bank Statement', value: 'bank statement' },
    { label: 'Proof of address', value: 'Proof of address' },
    { label: 'Passport', value: 'passport' },
    { label: 'Others', value: 'others' },
];

export default Profile;
